import { useEffect, useState, useCallback } from 'react';

/**
 * 현재 사용자의 LMS 권한 정보를 가져온다.
 *  - login: boolean
 *  - role : 'admin' | 'instructor' | 'student' | 'guest'
 *  - user_id, name
 *
 * /lms/me 가 통합 SSO 세션(req.session.user / req.session.userId / req.session.UserId)
 * 모두를 인식하므로 talk/store/edu/estimate 어디서 로그인했든 자동으로 식별됨.
 */
export default function useLMSAuth() {
  const [me, setMe] = useState({ login: false, role: 'guest', loading: true });

  const refresh = useCallback(async () => {
    try {
      const r = await fetch('/lms/me', { credentials: 'include' });
      if (!r.ok) {
        setMe({ login: false, role: 'guest', loading: false });
        return;
      }
      const d = await r.json();
      setMe({ ...d, loading: false });
    } catch (e) {
      setMe({ login: false, role: 'guest', loading: false });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { ...me, refresh };
}

export function isAdmin(role) { return role === 'admin'; }
export function isInstructor(role) { return role === 'admin' || role === 'instructor'; }
export function isStudent(role) { return role === 'student'; }
